<div class="container-carga-de-archivo">
  <div class="loader-carga-de-archivo">
    <div class="all-input-carga-de-archivo">
      <input
        type="file"
        [name]="inputName"
        [id]="inputName"
        [accept]="this.extensiones"
        class="input-carga-de-archivo active"
        multiple
        (change)="onFileSelected($event)" />
      <label [for]="inputName" class="label-carga-de-archivo">
        {{ etiqueta }}
        <span *ngIf="requerido" class="text-danger"> *</span></label
      >
      <label [for]="inputName" class="container-input-carga-de-archivo">
        <span class="button-file-carga-de-archivo">{{
          'carga-archivos.seleccione-archivo' | translate
        }}</span>
        <span class="file-name-carga-de-archivo">{{ selectedFileName }}</span>
      </label>
    </div>
    <div class="load-button-carga-de-archivo">
      <div class="load-carga-de-archivo">
        <div
          class="spinner-indicador-de-carga-govco"
          style="width: 32px; height: 32px; border-width: 6px"
          role="status">
          <span class="visually-hidden">{{
            'carga-archivos.cargando' | translate
          }}</span>
        </div>
      </div>
      <button
        class="button-loader-carga-de-archivo"
        [disabled]="files.length === 0 ||
        (listaArchivos.length && cantidadMaxAchivos ? listaArchivos.length > cantidadMaxAchivos : null)"
        (click)="uploadFile()"
        [attr.aria-label]="'carga-archivos.cargar' | translate">
        {{ 'carga-archivos.cargar' | translate }}
      </button>
    </div>
  </div>
  <div
    class="container-documento-guia"
    *ngIf="documentoGuia !== null && documentoGuia !== ''">
    <div
      class="content-wrapper"
      tabindex="0"
      role="button"
      (keydown)="onKeydown($event)"
      (click)="aDocumentoGuia()">
      <div class="file-alt-carga-de-archivo-govco"></div>
      <span class="text-validation-documento-guia">{{
        'carga-archivos.descargar' | translate
      }}</span>
    </div>
  </div>
  <div class="text-validation-carga-de-archivo">
    <p class="my-0 py-0">
      {{ 'carga-archivos.extension' | translate }} {{ extensiones }}<br />
    </p>
    <p class="my-0 py-0">
      {{ 'carga-archivos.minimo' | translate }}
      {{ tamanioMin }} Kb.
    </p>
    <p class="my-0 py-0">
      <span *ngIf="tamanioMax"
        >{{ 'carga-archivos.maximo' | translate }} {{ tamanioMax }} Kb.</span
      >
    </p>
  </div>

  <div class="container-detail-carga-archivo-govco">
    <span class="alert-carga-archivo-govco" *ngIf="error">{{
      mensajeError
    }}</span>
    <div class="attached-files-carga-archivo-govco">
      <div
        class="attached-file-carga-de-archivo"
        tabindex="0"
        *ngFor="let file of listaArchivos">
        <div class="icon-text-carga-de-archivo">
          <span class="govco-svg">
            <img
              src="assets/img/file-alt-white.svg"
              alt="Se cargo un documento"
              class="style-icos-upload-files" />
          </span>
          <div class="container-text-name-carga-de-archivo">
            <span class="text-name-carga-de-archivo-govco">{{
              file.name
            }}</span>
            <span>{{ bytesToKb(file.size) }} Kb</span>
          </div>
        </div>
        <button class="btn" (click)="removeFile(file)"
        aria-label="Eliminar">
          <img
            src="assets/img/trash-white.svg"
            alt="Borrar archivo cargado"
            class="style-icos-upload-files" />
        </button>
      </div>
    </div>
  </div>
</div>
